import { render, staticRenderFns } from "./UnBidding.vue?vue&type=template&id=4318e87e&scoped=true&"
import script from "./UnBidding.vue?vue&type=script&lang=js&"
export * from "./UnBidding.vue?vue&type=script&lang=js&"
import style0 from "./UnBidding.vue?vue&type=style&index=0&id=4318e87e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4318e87e",
  null
  
)

export default component.exports